import Composition from 'models/composition';
import getCompositionsStore from 'actions/customer/lib/get_compositions_store';
import { isSending } from 'actions/composition/lib/in_flight_sends';

export default class AbortUpload {
  constructor(context) {
    this.context = context;
  }

  run({ compositionId, uploadId }) {
    // Uploads can't change while a send that carries them is out.
    if (isSending(this.context, compositionId)) {
      return;
    }

    const compositionsStore = getCompositionsStore(this.context);
    let composition = compositionsStore.find(compositionId);
    if (!composition.removeAttachment(uploadId)) {
      return;
    }
    compositionsStore.replace(composition);

    let path = Composition.getUploadPath(compositionId, uploadId);
    this.context.gateways.compositionUpload.abort(path);
  }
}
